// export const myInfo = {
//   name: '성명',
//   sabun: '사번',
//   empStatus: '재직상태',
//   department: '부서',
//   startWorkDt: '근무시작',
//   endWorkDt: '근무종료',
//   address: '주소',
//   email: '이메일',
//   hp: '휴대전화',
//   officePhone: '사내전화',
// };
export const myInfo = {
  name: '김길동',
  sabun: '0015',
  empStatus: '재직중',
  department: '솔루션개발팀',
  startWorkDt: '2021.10.15',
  endWorkDt: '2024.12.30',
  address: '경기도 성남시 분당구 소새울로 134-1',
  email: 'kd.go@gmail.com',
  hp: '010-1112-1133',
  officePhone: '031-5503-5444',
};
export const myInfo_org = {
  end_date: '20241231',
  chk_cd: '',
  birth_date: '19900101',
  is_addtax_divided: 'N',
  nation_code: '',
  zip_code: '55555',
  passport_num: '',
  changpay_val: '100',
  place_cd: '',
  res_id: '9001011111111',
  is_foreign_passport: 'N',
  is_work: 'Y',
  is_residential: 'Y',
  is_foreign_tax: 'N',
  acct_year: '2024',
  tel_2: '',
  email: 'test@test.com',
  is_handy: '0',
  place_id: '',
  tel_1: '021112222',
  start_date: '20240101',
  add: '서울 강남구',
  job_position: '',
  is_owner: 'Y',
  place_busnid: '',
  sex: '1',
  co_id: 'test1',
  is_foreign_corp: 'N',
  deptname: '테스트',
  cel_number: '01012345678',
  co_cd: '0001',
  passwd: '',
  red_start_date: '',
  is_foreign: 'N',
  name: '일길동',
  red_end_date: '',
  chk_dtail_cd: '',
};

export const familyInfo = {
  init: {
    is_deduct_single_parent: '', //한부모 공제여부
    co_id: '', //회사코드
    family_seqid: 0, //부양가족 seq
    family_cd: '', //가족코드
    family_type: '1', // 가족유형
    is_hc_exception: 'N', //건강보험산정특례자
    is_deduct_women: 'N', //부녀자공제
    child_cd: '0', //자녀코드
    is_adopt: 'N', //입양여부
    co_cd: '', //회사코드
    is_ele_deduct: 'N', //기본공제여부
    res_id: '', //주민번호
    is_foreign: 'N', //외국인여부
    name: '', //이름
    is_incom: 'Y', //소득여부
    acct_year: '', //연말정산년도
    adopt_date: '', //입양일
    is_handy: '0', //장애인여부
  },

  data: [
    {
      is_deduct_single_parent: 'N', //한부모공제
      co_id: 'test1', //사번
      family_seqid: 10, //부양가족 seq
      family_cd: '', //가족코드
      family_type: '0', // 가족유형
      is_hc_exception: 'N', //건강보험산정특례자
      is_deduct_women: 'N', //부녀자공제
      child_cd: '0', //자녀코드
      is_adopt: 'N', //입양여부
      co_cd: '0001', //회사코드
      is_ele_deduct: 'Y', //기본공제여부
      res_id: '9001011111111', //주민번호
      is_foreign: 'N', //외국인여부
      name: '일길동', //이름
      is_incom: 'Y', //소득여부
      acct_year: '2024', //연말정산년도
      adopt_date: '', //입양일
      is_handy: '0', //장애인여부
    },
    {
      is_deduct_single_parent: 'N',
      co_id: 'test1',
      family_seqid: 11,
      family_cd: '',
      family_type: '4',
      is_hc_exception: 'N',
      is_deduct_women: 'N',
      child_cd: '0',
      is_adopt: 'N',
      co_cd: '0001',
      is_ele_deduct: 'Y',
      res_id: '1001014111112',
      is_foreign: 'N',
      name: '일자녀',
      is_incom: 'Y',
      acct_year: '2024',
      adopt_date: '',
      is_handy: '0',
    },
  ],
};
export const familyInfo_org = {
  // {
  //   idx: 0,
  //   name: '성명',
  //   residentNumberFr: '주민번호',
  //   residentNumberBe: '주민번호',
  //   relation: '가족관계',
  //   detailRelation: '상세관계',
  //   disabledPerson: 장애인여부,
  //   adoptionYN: 입양여부,
  //   adoptionDate: 입양일,
  //   healthInsuranceYN: 건강보험특례자여부,
  //   incomeDeduction: 세금공제(기본공제),
  //   womenDeduction: 부녀자공제,
  //   oneParentDeduction: 한부모공제,
  //   oldDeduction: 경로우대공제,
  //   disableDeduction: 장애인공제,
  //   childDeduction: 자녀세액공제,
  //   birthDeduction: 출생공제,
  //   adoptionDeduction: 입양자공제,
  // },
  init: {
    name: '',
    residentNumberFr: '',
    residentNumberBe: '',
    relation: '',
    detailRelation: '',
    disabledPerson: false,
    adoptionYN: false,
    adoptionDate: '',
    healthInsuranceYN: false,
    incomeDeduction: false,
    womenDeduction: false,
    oneParentDeduction: false,
    oldDeduction: false,
    disableDeduction: false,
    childDeduction: false,
    birthDeduction: false,
    adoptionDeduction: false,
  },
  data: [
    {
      idx: 0,
      name: '박말숙',
      residentNumberFr: '860420',
      residentNumberBe: '2040114',
      relation: '처',
      detailRelation: '처',
      disabledPerson: false,
      adoptionYN: false,
      adoptionDate: '',
      healthInsuranceYN: true,
      incomeDeduction: true,
      womenDeduction: true,
      oneParentDeduction: false,
      oldDeduction: false,
      disableDeduction: false,
      childDeduction: false,
      birthDeduction: false,
      adoptionDeduction: false,
    },
    {
      idx: 1,
      name: '고진아',
      residentNumberFr: '860420',
      residentNumberBe: '2040114',
      relation: '자녀',
      detailRelation: '딸',
      disabledPerson: false,
      adoptionYN: false,
      adoptionDate: '',
      healthInsuranceYN: false,
      incomeDeduction: false,
      womenDeduction: false,
      oneParentDeduction: false,
      oldDeduction: false,
      disableDeduction: false,
      childDeduction: false,
      birthDeduction: false,
      adoptionDeduction: false,
    },
  ],
};
